import { Arrow as TooltipPrimitiveArrow, Content as TooltipPrimitiveContent } from "@radix-ui/react-tooltip";
import { styled } from "@vitality-ds/system";
import baseTooltipArrowStyles from "./styles/BaseTooltipArrow.styles";
import baseTooltipContentStyles from "./styles/BaseTooltipContent.styles";
export var BaseTooltipArrow = styled(TooltipPrimitiveArrow, baseTooltipArrowStyles);
export var BaseTooltipContent = styled(TooltipPrimitiveContent, baseTooltipContentStyles);